import {
    buildSectionSelector,
    normalizeSectionId,
    sectionRenderer,
} from "@theme/section-renderer";
import { morph } from "@theme/morph";

if (!customElements.get("discount-card")) {
    class DiscountCard extends HTMLElement {
        connectedCallback() {
            this.init();
        }

        disconnectedCallback() {
            window.removeEventListener("popstate", this.historyChangeHandler);
            this.removeEventListener("click", this.clickHandler);
        }

        init() {
            this.sectionId = this.dataset.sectionId;
            this.collectionHandle = this.dataset.collectionHandle;
            this.results = document.getElementById("filter-results");
            this.mediaWrapper = this.querySelector(".media");
            this.addListeners();
        }

        addListeners() {
            this.addEventListener("click", this.clickHandler.bind(this));
        }

        async clickHandler(event) {
            event.preventDefault();
            const tag = this.dataset.tag;
            const normalizedId = normalizeSectionId(this.sectionId);
            const section = document.getElementById(
                buildSectionSelector(normalizedId),
            );

            if (!section) {
                throw new Error(
                    `Section with id ${this.sectionId} not found in the DOM.`,
                );
            }

            try {
                const fetchUrl = `/collections/${this.collectionHandle}/${tag}`;
                const main = document.querySelector("main");

                window.history.pushState({}, "", fetchUrl);
                // Set loading state.
                this.results.classList.add("is-loading");

                if (this.mediaWrapper)
                    this.mediaWrapper.classList.add("is-loading");

                if (this.fetchAbortController) {
                    this.fetchAbortController.abort("Request changed");
                }
                this.fetchAbortController = new AbortController();

                const response = await fetch(fetchUrl, {
                    method: "GET",
                    signal: this.fetchAbortController.signal,
                });

                if (!response.ok) {
                    throw new Error(
                        `Failed to fetch updated section: ${response.statusText}`,
                    );
                }

                const responseText = await response.text();
                const newHtml = new DOMParser().parseFromString(
                    responseText,
                    "text/html",
                );
                const newMain = newHtml.querySelector("main");

                if (!main || !newMain) {
                    throw new Error("No new main source found");
                }

                morph(main, newMain);
                window.dispatchEvent(
                    new CustomEvent("on:breakpoint-change", { bubbles: true }),
                );
            } catch (error) {
                console.log(error);
            } finally {
                this.results.classList.remove("is-loading");
                if (this.mediaWrapper)
                    this.mediaWrapper.classList.remove("is-loading");
            }
        }
    }

    customElements.define("discount-card", DiscountCard);
}
